module.exports = __webpack_public_path__ + "static/fonts/LavaPro-MedIta.dd902b4.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/LavaPro-MedIta.woff
// module id = xXqM
// module chunks = 0